"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Url = {
    home: "home",
    lgoin: "login",
    firebaseAuthToken: "firebase-authn-token",
};
exports.default = Url;
